import React, { Component } from 'react';
import * as CurrencyFormat from 'react-currency-format';
import localStorage from 'local-storage';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {Button} from 'react-bootstrap';

class FundReturns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: "percentages",
            fundReturns: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        let fundReturns = [];
        props.fundReturns && props.fundReturns.map(fundReturn => fundReturns.push(fundReturn))

        return {
            fundReturns: fundReturns
        }
    }

    handleShowIn(e) {
        this.setState({ checked: e.target.id })
    }

    _showNote(e) {
        document.getElementById('ViewReturnDetails').style.display = 'none'
        document.getElementById('note').style.display = 'block';
    }

    _hideNote(e) {
        document.getElementById('note').style.display = 'none';
        document.getElementById('ViewReturnDetails').style.display = 'block';
    }

    render() {
        const { t } = this.props
        const pageType = "fund"
        return (
            <div style={{ marginTop: "20px" }}>
                <table style={{ width: "100%" }}>
                    <thead>
                        <th style={{ textAlign: "left" }}>{t('balanceDetails:netInvestments')}{moment(localStorage.startDate).format('DD MMMM YYYY')}</th>
                        <th style={{ textAlign: "right" }}>{t('balanceDetails:showIn')}
                            <input type="radio" id="percentages" checked={this.state.checked === "percentages"}
                                onClick={e => this.handleShowIn(e)} />{t('balanceDetails:percentages')}(%)
                            <input type="radio" id="dollars" checked={this.state.checked === "dollars"}
                                onClick={e => this.handleShowIn(e)} />{t('balanceDetails:dollars')}($)
                        </th>
                    </thead>
                </table>
                <table id="FundDetailsTab" style={{ marginLeft: "-1px", marginRight: "1px" }} className="table-responsive superlifeLegacyPlan">
                    <thead>
                        <th style={{ height: 30 }}></th>
                        {
                            !this.state.fundReturns || this.state.fundReturns.length <= 0 ? "" : !this.props.displayHeaders ? "" :
                                this.props.displayHeaders.map(funds => <th>{funds ? funds.fund : ""}</th>)
                        }
                        <th>{t('balanceDetails:totalFunds')}</th>
                    </thead>
                    <tbody>
                        {
                            this.props.isFundReturnsEmpty ? <div className="tabMessage">No Fund Returns</div> :
                            !this.state.fundReturns || this.state.fundReturns.length === 0 ? <div className="tabMessage">{t('fetching') + " " + t('fund') + " " + t('returns')}...</div> :
                                // this.props.fundReturns.length <= 0 ?
                                //     <div className="tabMessage">{t('no') + " " + t('fund')}s....</div> :
                                    this.state.fundReturns.map((fundReturn, index) =>
                                        <tr key={index}>
                                            <td style={{ textAlign: "left" }}>{fundReturn.description}</td>
                                            {
                                                this.props.clicked === "next" ? !fundReturn.funds ? " " : fundReturn.funds.length > 4 ?
                                                    this.props.nextClickCount + 4 <= this.props.totalHeaders.length ?
                                                        fundReturn.funds.slice(this.props.nextClickCount, this.props.nextClickCount + 4)
                                                            .map(fund =>
                                                                <td>{this.state.checked === "dollars" ?
                                                                    !fund.amount || fund.amount === 0 ? "n/a" :
                                                                        <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'$'} /> :
                                                                    !fund.percentage ? "n/a" : fund.percentage + "%"}</td>) :
                                                        fundReturn.funds.slice(this.props.nextClickCount, this.props.totalHeaders.length)
                                                            .concat(fundReturn.funds.slice(0, 4 - (this.props.totalHeaders.length - this.props.nextClickCount)))
                                                            .map(fund =>
                                                                <td>{this.state.checked === "dollars" ?
                                                                    !fund.amount || fund.amount === 0 ? "n/a" :
                                                                        <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'$'} /> :
                                                                    !fund.percentage ? "n/a" : fund.percentage}</td>) :
                                                    fundReturn.funds.map(fund => <td>{this.state.checked === "dollars" ?
                                                        !fund.amount || fund.amount === 0 ? "n/a" :
                                                            <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                prefix={'$'} /> :
                                                        !fund.percentage ? "n/a" : fund.percentage + "%"}</td>) :

                                                    this.props.clicked === "prev" ? !fundReturn.funds ? " " : fundReturn.funds.length > 4 ?
                                                        this.props.prevClickCount + 4 >= this.props.totalHeaders.length ?
                                                            fundReturn.funds.slice(this.props.prevClickCount, this.props.totalHeaders.length)
                                                                .concat(fundReturn.funds.slice(0, 4 - (this.props.totalHeaders.length - this.props.prevClickCount)))
                                                                .map(fund =>
                                                                    <td>{this.state.checked === "dollars" ?
                                                                        !fund.amount || fund.amount === 0 ? "n/a" :
                                                                            <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                                prefix={'$'} /> :
                                                                        !fund.percentage ? "n/a" : Number(fund.percentage).toFixed(2) + "%"}</td>) :
                                                            fundReturn.funds.slice(this.props.prevClickCount, this.props.prevClickCount + 4).map(fund =>
                                                                <td>{this.state.checked === "dollars" ?
                                                                    !fund.amount || fund.amount === 0 ? "n/a" :
                                                                        <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'$'} /> :
                                                                    !fund.percentage ? "n/a" : Number(fund.percentage).toFixed(2) + "%"}</td>) :
                                                        fundReturn.funds.slice(0, fundReturn.funds.length).map(fund =>
                                                            <td>{this.state.checked === "dollars" ?
                                                                !fund.amount || fund.amount === 0 ? "n/a" :
                                                                    <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                        displayType={'text'}
                                                                        thousandSeparator={true}
                                                                        prefix={'$'} /> :
                                                                !fund.percentage ? "n/a" : Number(fund.percentage).toFixed(2) + "%"}</td>) : ""
                                            }
                                            <td>{this.state.checked === "dollars" ?
                                                !fundReturn.totalAmt || Number(fundReturn.totalAmt).toFixed(2) === 0 ?
                                                    "n/a" : <CurrencyFormat value={Number(fundReturn.totalAmt).toFixed(2)}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        prefix={'$'} /> : !fundReturn.totalPct ?
                                                    "n/a" : Number(fundReturn.totalPct).toFixed(2) + "%"}</td>
                                        </tr>)
                        }
                    </tbody>
                </table>

                <table>
                    <tbody>
                        <tr style={{ fontSize: "12px" }}>{t("AccountBalance:ReturnsAreOnly", {pageType})}</tr>
                    </tbody>
                </table>
                <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px" }}>{t("AccountBalance:TheInvestmentReturns")}
                            <span id="ViewReturnDetails">
                                To view more details 
                                <Button style={{ color: "#50833C", background: 'none', border: 'none', fontWeight: 'bold', cursor: 'pointer'}}
                                    onClick={e => this._showNote(e)}>click here</Button>
                            </span>
                        </tr>
                    </tbody>
                </table>
                {/* <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px" }}>{t("AccountBalance:TheTotalFunds")}
                            <Button style={{ color: "#50833C", background: 'none', border: 'none', fontWeight: 'bold'}}
                                onClick={e => this._showNote(e)}>click here</Button>
                        </tr>
                    </tbody>
                </table> */}
                <table style={{marginTop: '10px'}}>
                    <tbody>
                        <tr style={{fontSize: "12px"}}>
                            <p id='note' style={{display: 'none'}}>
	                            <a name="returnDet"></a>
	                            <span id="ReturnDetails"> 
                                    <b>Note:</b> The returns shown are the returns calculated by taking the actual dollar amount of the investment earnings after-tax and after all expenses and dividing it by the average level of the account/Fund balance for the period. It therefore reflects the actual cash flow and timing of the cash flow relevant to you. Members with different cash flows will have different returns. Returns that are for the periods of less than one year, are for the period and are <u>not</u> an annual return. Returns for periods longer than 1 year are the annualised returns (i.e. are the average annual return). 
                                </span>
	                            <span id="HideReturnDetails">
                                    To hide details
                                    <Button style={{ color: "#50833C", background: 'none', border: 'none', fontWeight: 'bold', cursor: 'pointer'}}
                                        onClick={e => this._hideNote(e)}>click here</Button>

                                </span>
                            </p>
                        </tr>
                    </tbody>
                </table>
                <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px" }}>{t("AccountBalance:Remember")}</tr>
                    </tbody>
                </table>
                {/* <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px" }}>{t("AccountBalance:ToViewByPool")}<Link to="/" style={{ color: "#50833C" }}>click here</Link></tr>
                    </tbody>
                </table>
                <table style={{ marginTop: "10px", paddingBottom: "25px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px" }}>{t("AccountBalance:ToViewYourStatements")}<Link to="/" style={{ color: "#50833C" }}>click here</Link></tr>
                    </tbody>
                </table> */}

            </div>
        )
    }
}

export default FundReturns;